


























import { Geek, Localization } from '@/models';
import { typedStore } from '@/store';
import Vue from 'vue';
import mixins from 'vue-typed-mixins';

export default Vue.extend({
  name: 'GCoinsNav',
  props: {
    geek: Object as () => Geek,
  },
  computed: {
    localization(): Localization {
      return typedStore(this).state.geek.current.localization;
    },
  },
});
